import React, { useEffect, useState } from 'react';
import CSVReader from 'react-csv-reader';
import Papa from 'papaparse';
import PlayerDTO from '../../../../v2/DTO/PlayerDTO.js';
import { getAllV2Sport, postV2Player, postV2Team } from '../../../../api/index.js';
import useFetch from '../../../../v2/hooks/useFetch.js';
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import TeamDTO from '../../../../v2/DTO/TeamDTO.js';

const ActorsImport = ({ importType }) => {
  const [data, setData] = useState([]);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const { data : sports, fetchData : fetchSports} = useFetch(getAllV2Sport, []);

  const { data : createdData, isLoading, error, fetchData } = useFetch(importType==='players' ? postV2Player : postV2Team, [data]);

  useEffect(() => {
    setStep(1)
    setData([])
    setLoading(false)
    setResult(null)
  }, [importType])

  useEffect(() => {
    fetchSports()
  }, [])

  const convertDateFormat = (dateStr) => {
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month}-${day}`;
  };

  const handleFileLoad = (data) => {
    // Utiliser PapaParse pour parser le CSV avec encodage UTF-8
    const csvData = Papa.parse(Papa.unparse(data), {
      header: true,
      skipEmptyLines: true,
      encoding: "UTF-8"
    }).data;

    const dtos = csvData.map(d => {
      const { sport, discipline } = d;
      const foundSport = sports.find(s => s.idName === sport);
      const foundDiscipline = foundSport?.disciplines.find(dis => dis.idName === discipline);



      if(importType === 'players'){
        return new PlayerDTO({ ...d, disciplines: [foundDiscipline], birthdate : convertDateFormat(d.birthdate)});
      }else if(importType === 'teams'){
        return new TeamDTO({ ...d, disciplines: [foundDiscipline] });
      }
    });

    setData(dtos.filter(d => d.provider));
    setStep(2);
  };

  const handleSubmit = () => {
    setLoading(true);

    fetchData()
  };

  useEffect(() => {
    setLoading(false);

    if(error){
        setResult({ error: "Failed to import data" });
        setStep(3);
    } else if(createdData){
        setResult(createdData);
        setStep(3);
    }
  }, [createdData, error])

  const renderTableHeader = () => {
    if (data.length === 0) return null;
    return (
      <TableHead>
        <TableRow>
          {Object.keys(data[0]).map((key) => (
            <TableCell sx={{fontWeight : 'bold'}} key={key}>{key}</TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };
  
  const renderTableRows = () => {
    return (
      <TableBody>
        {data.map((dto, index) => (
          <TableRow key={index}>
            {Object.values(dto).map((value, idx) => (
              Array.isArray(value) && value.length > 0 ? (
                <TableCell key={idx}>{value[0].idName || JSON.stringify(value)}</TableCell>
              ) : (
                <TableCell key={idx}>{typeof value === 'object' && value !== null ? JSON.stringify(value) : value}</TableCell>
              )
            ))}
          </TableRow>
        ))}
      </TableBody>
    );
  };


  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <CSVReader
            onFileLoaded={handleFileLoad}
            parserOptions={{ header: true }}
          />
        );
      case 2:
        return (
            <Box sx={{textAlign : 'center'}}>
              <Typography fontSize="1.2em">Etape de validation - {importType}</Typography>
              <Typography fontSize="1.2em">{data.length} {importType}</Typography>
              <Box m={5}>
                <Button onClick={() => setStep(1)}>Annuler</Button>
                <Button variant="contained" onClick={handleSubmit}>VALIDER</Button>
              </Box>
              
              <Table>
                {renderTableHeader()}
                {renderTableRows()}
              </Table>
              <Box m={5}>
                <Button onClick={() => setStep(1)}>Annuler</Button>
                <Button variant="contained" onClick={handleSubmit}>VALIDER</Button>
              </Box>
            </Box>
          );
      case 3:
        return (
          <Box>
            <Typography variant='h6'>Resultats - {importType}</Typography>
            {result ? (
              result.length ? <Typography variant='body' fontSize='1.1em'>{result.length} {importType}</Typography> : <pre>{JSON.stringify(result, null, 2)}</pre>
            ) : (
              <p>No result</p>
            )}
            <br/>
            <Button onClick={() => setStep(1)}>Importer un autre fichier</Button>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Box>
      <Typography variant="subtitle">{importType}</Typography>
      {loading ? <p>Loading...</p> : renderStep()}
    </Box>
  );
};

export default ActorsImport;